import { GameLayer } from "./GameLayer";
export class GameMapControl extends GameLayer {
    constructor(config, content) {
        super();
        this.config = config;
        this.content = content;
        this.parent = null;
        if (!this.config.no_default_styling)
            this.content.addClass("gamemap-ui-control-default-styling");
        switch (this.config.type) {
            case "gapless":
                this.content.addClass("gamemap-ui-control-gapless");
                break;
            case "floating":
                this.content.addClass("gamemap-ui-control-floating");
                break;
        }
        // Disable events propagating to the map // TODO: Do I really need this?
        this.content.container.on("contextmenu blur change click dblclick error focus focusin focusout hover keydown keypress keyup load mousedown mouseenter mouseleave mouseout mouseover resize select submit mousewheel", (e) => e.stopPropagation());
    }
    onAdd(map) {
        map.addControl(this);
        return super.onAdd(map);
    }
    onRemove(map) {
        this.content.detach();
        return super.onRemove(map);
    }
    setContent(content) {
        this.content.empty().append(content);
        return this;
    }
}
